document.addEventListener('DOMContentLoaded', () => {
document.addEventListener('DOMContentLoaded', () => {

    // ========================================================================
    // 1. LÓGICA DE SWATCHES (Cambio de variante visual)
    // ========================================================================
    const swatchRadios = document.querySelectorAll('.swatch-element input[type="radio"]');

    swatchRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            const element = e.target;
            const variantId = element.value;
            const price = element.getAttribute('price');

            // Usamos .closest() para encontrar el contenedor padre de forma segura
            // sin importar si cambias la estructura HTML en el futuro.
            const productContainer = element.closest('.product-item') || element.closest('.product-form');

            if (productContainer) {
                // A. Actualizar el Select Oculto Maestro (Necesario para el formulario)
                const selectElement = productContainer.querySelector('select[name="id"]');
                if (selectElement) {
                    selectElement.value = variantId;
                    
                    // IMPORTANTE: Disparamos el evento 'change' manualmente.
                    // Esto "despierta" al tema moderno para que sepa que la variante cambió.
                    // Esto suele actualizar fotos o stocks automáticamente si el tema lo soporta.
                    selectElement.dispatchEvent(new Event('change', { bubbles: true }));
                }

                // B. Actualizar Precio Visualmente (Tu lógica visual)
                const priceElement = productContainer.querySelector('.product-item__price');
                if (priceElement && price) {
                    // Actualizamos el texto. Nota: Si el tema usa formatMoney, 
                    // quizás prefieras dejar que el evento 'product:variant-change' lo haga,
                    // pero mantener esto asegura que tu diseño personalizado funcione.
                    priceElement.innerText = price;
                }
            }
        });
    });

    // ========================================================================
    // 2. TOGGLE DE PAÍSES (UI)
    // ========================================================================
    const buttonToggleCountry = document.querySelector('.dropdown-country .toggel-country');
    if (buttonToggleCountry) {
        buttonToggleCountry.addEventListener('click', (e) => {
            // Prevenimos comportamiento por defecto si es un enlace
            e.preventDefault(); 
            const countryList = buttonToggleCountry.parentElement.querySelector('.country-list');
            if (countryList) {
                // Usamos toggle de clase para mejor rendimiento CSS
                // Asegúrate de tener CSS: .country-list[style*="block"] o usar una clase .is-active
                if (countryList.style.display === 'block') {
                    countryList.style.display = 'none';
                } else {
                    countryList.style.display = 'block';
                }
            }
        });
    }

    // ========================================================================
    // 3. INTEGRACIÓN CON EVENTOS DEL TEMA (Sustituye tu fetch manual)
    // ========================================================================
    
    /**
     * NOTA: He eliminado el bloque 'form.addEventListener("submit"... fetch...)'.
     * ¿Por qué? Porque tu tema moderno ya tiene "Ajax Cart" habilitado.
     * Al usar el formulario estándar <form data-product-form>, el tema intercepta
     * el envío y agrega el producto sin recargar la página.
     * * Usamos los siguientes eventos para reaccionar al éxito o error.
     */

    // Escuchar cuando un producto se agrega correctamente
    document.addEventListener("cart:item-added", function (evt) {
        console.log("✅ Producto agregado con éxito:", evt.detail.product);

        // Si tu tema no abre el carrito automáticamente, aquí podrías forzarlo.
        // Pero la mayoría de temas modernos abren el "Quick Cart" solos al recibir este evento.
        
        // Si necesitas lógica visual específica para tu diseño:
        const quickCart = document.querySelector(".quick-cart");
        if (quickCart && !quickCart.classList.contains('active')) {
             // Opcional: Forzar apertura si el tema no lo hace
             // quickCart.classList.add("animation--quick-cart-revealed");
        }
    });

    // Escuchar errores (ej: sin stock)
    document.addEventListener("cart:error", function (evt) {
        console.error("❌ Error al agregar:", evt.detail.errorMessage);
        alert(evt.detail.errorMessage || 'No se pudo agregar el producto. Revise el stock.');
    });

    // Escuchar cuando el carrito se abre (para animaciones o clases extra)
    document.addEventListener("quick-cart:open", function (evt) {
        console.log("🛒 Quick Cart Abierto");
        // Aquí puedes agregar clases visuales extra si tus estilos antiguos lo requieren
        // Ejemplo: document.body.classList.add('no-scroll');
    });

    // ========================================================================
    // 4. ESCUCHAR CAMBIOS DE VARIANTE (Nativo del tema)
    // ========================================================================
    // Este evento se dispara cuando el tema detecta el cambio (gracias al dispatchEvent de arriba)
    document.addEventListener("product:variant-change", function (evt) {
        // evt.detail.variant contiene toda la info de la variante (precio, imagen, etc.)
        // Útil si quieres actualizar algo más avanzado que solo el precio.
        console.log("Variante detectada por el tema:", evt.detail.variant);
    });

});

    // ========================================================================
    // 4. ESCUCHAR CAMBIOS DE VARIANTE (Nativo del tema)
    // ========================================================================
    // Este evento se dispara cuando el tema detecta el cambio (gracias al dispatchEvent de arriba)
    document.addEventListener("product:variant-change", function (evt) {
        // evt.detail.variant contiene toda la info de la variante (precio, imagen, etc.)
        // Útil si quieres actualizar algo más avanzado que solo el precio.
        console.log("Variante detectada por el tema:", evt.detail.variant);
    });

});